import defaultAvatar from "../assets/images/user.png";

// One answer to "what goes in the img" for people who have no picture.
//
// A missing avatar was rendered as src="", which browsers draw as a broken
// image icon. It became visible when the old S3 bucket was deleted and the
// avatars pointing into it were cleared, but an account has always been able to
// exist without one.
export const avatarSrc = (value) =>
  typeof value === "string" && value.trim() ? value : defaultAvatar;

// And for a stored address that no longer resolves. Hundreds of avatars still
// point at Cloudinary, which this project no longer uses for anything else.
//
// The guard matters: without it a failing default would fire this handler again
// on every attempt and spin.
export const onAvatarError = (event) => {
  const img = event?.currentTarget;
  if (!img || img.dataset.fallbackApplied) return;
  img.dataset.fallbackApplied = "1";
  img.src = defaultAvatar;
};
